export default {

    "hero_title_5": "Platform video karaoke by Happy Puppy Group",
    "hero_sub_5": "Mulai Rp 5.000, bisa karaoke sepuasnya",
    "hero_title_6": "Karaoke seru di rumah!",
    "hero_sub_6": "Beli produk RiSing dengan 3 cara mudah",
    "hero_title_7": "Perpanjang akses lagu karaoke dengan sekali klik!",
    "hero_sub_7": "Cukup pilih paket langganan dan lanjutkan karaoke kapan saja",
    "showcase_3_2_label": "Mode MV & Karaoke",
    "showcase_3_2_desc": "Nikmati karaoke dengan atau tanpa vokal penyanyi",
    "showcase_4_2_label": "Mode Mixer",
    "showcase_4_2_desc": "Naik turunkan nada dasar hingga ± 3 semitone sesuai jangkauan suara",


    "nav_about_us": "Tentang Kami",
    "nav_products": "Produk",
    "nav_shop": "Toko",
    "nav_news": "Berita",
    "nav_help": "Pusat Bantuan",
    "nav_activation": "Aktivasi Perangkat",
    "nav_products_explore": "Jelajahi Produk RiSing",
    "nav_products_stb": "RiSing Karaoke Set-Top Box",
    "nav_products_console": "RiSing Karaoke Console One",

    "learn_more_btn": "Pelajari Selengkapnya",
    "tutor_title": "3 LANGKAH MUDAH PAKAI RISING",
    "tutor_step_1": "Hubungkan ke arus listrik",
    "tutor_step_2": "Hubungkan ke TV dan speaker",
    "tutor_step_3": "Sambungkan ke Wi-Fi",
    "advantage_title": "KEUNGGULAN KARAOKE DI RUMAH LEBIH MUDAH DENGAN RISING",
    "advantage_f1_title": "Mulai karaoke dalam hitungan detik",
    "advantage_f1_desc": "Sambungkan ke TV dan/atau speaker, hubungkan ke Wi-Fi, Anda siap untuk karaoke",
    "advantage_f2_title": "Akses 80.000+ lagu karaoke",
    "advantage_f2_desc": "Temukan berbagai pilihan lagu, mulai dari lagu daerah, lagu Indonesia, hingga lagu mancanegara dengan berbagai genre",
    "advantage_f3_title": "Kontrol langsung dari HP",
    "advantage_f3_desc": "Scan QR di layar TV, lalu gunakan HP untuk memilih lagu dan mengontrol karaoke dengan lebih praktis.",
    "advantage_f4_title": "Cuma mulai Rp5.000 per hari",
    "advantage_f4_desc": "Nikmati karaoke sepuasnya di rumah dengan akses lagu mulai Rp5.000 per hari.",
    "退出登录": "Keluar",
    "下载": "Unduh",
    "收银员用户下载": "Unduh Aplikasi Kasir",
    "谷歌浏览器下载": "Unduh Google Chrome",
    "阳光官网": "Situs Resmi Sunshine",
    "24小时客服热线": "Layanan Pelanggan 24 Jam",
    "点击跳转": "Klik untuk menuju",
    "点击复制": "Klik untuk menyalin",
    "账户": "Akun",
    "账户小写": "Akun",
    "商店": "Toko",
    "商店小写": "Toko",
    "帮助中心": "Pusat Bantuan",
    "帮助中心小写": "Pusat bantuan",
    "首页": "Beranda",
    "订阅": "Langganan",
    "订阅1": "Langganan",
    "订阅大写": "Langganan",
    "订阅详情": "Detail langganan",
    "订阅文字": "Kelola layanan RiSing",
    "订单文字": "Lihat riwayat pesanan",
    "计费文字": "Lihat tagihan dan pembayaran",
    "此字段是必填的": "wajib diisi",
    "设置文字": "Perbarui profil dan pengguna",
    "订单": "Pesanan",
    "计费": "Penagihan",
    "设置": "Pengaturan",
    "你好": "Hai, selamat datang kembali!",
    "字幕描述": "Yuk masuk/daftar dulu untuk mempermudah kamu dalam transaksi kedepannya!",
    "使用电子邮件链接登录": "Masuk dengan link email",
    "使用验证码登录": "Masuk dengan kode OTP",
    "Email": "Email",
    "继续": "Lanjutkan",
    "或者": "Atau",
    "其他方式登录": "Cara lain untuk masuk",
    "用手机号": "Lanjutkan dengan Nomor Ponsel",
    "用email": "Lanjutkan dengan Email",
    "用谷歌": "Lanjutkan dengan Google",
    "还没有Rising账号？": "Belum punya akun RiSing?",
    "注册账号": "Daftar sekarang dan nikmati karaoke di rumah bersama RiSing!",
    "手机号": "Nomor Ponsel",
    "注册": "Daftar untuk mulai bernyanyi",
    "注册1": "Daftar",
    "其他方式注册": "Cara lain untuk mendaftar",
    "手机号注册": "Daftar dengan nomor ponsel",
    "谷歌注册": "Daftar dengan Google",
    "已有账号": "Sudah punya akun Rising",
    "登录": "Masuk",
    "注册小写": "Daftar",
    "下一步": "Berikutnya",
    "第一步": "Langkah 1 dari 3",
    "第一步2": "Langkah 1 dari 2",
    "创建密码": "Buat kata sandi",
    "密码": "Kata sandi",
    "再次输入密码": "Konfirmasi",
    "此外": "Selanjutnya",
    "密码已更新": "Anda dapat masuk dengan kata sandi baru.",
    "您的密码已成功更新。": "Kata sandi kamu telah berhasil diperbarui.",
    "确认新密码": "Konfirmasi",
    "第二步": "Langkah 2 dari 3",
    "第二步2": "Langkah 2 dari 2",
    "关于自己": "Silakan ceritakan tentang diri Anda",
    "生日": "Tanggal lahir",
    "性别": "Jenis kelamin",
    "入门套装": "Lihat Detail Paket",
    "查看产品详情": "Lihat Detail Produk",
    "取消": "Batal",
    "保存": "Simpan",
    "specs_title": "Spesifikasi Produk",
    "产品尺寸": "Dimensi Produk",
    "包装尺寸": "Dimensi Kemasan",
    "包裹重量": "Berat Paket",
    "plt": "P x L x T",
    "加入购物车": "Tambah ke keranjang",
    "商品已添加到购物车": "Produk ditambahkan ke keranjang",
    "商品已从购物车中移除": "Produk dihapus dari keranjang",
    "自动续订": "Perpanjangan otomatis",
    "安装指南": "Panduan instalasi",
    "您的购物车里什么都没有。前往商店订购商品。": "Keranjang Anda kosong. Silakan ke toko untuk memesan produk.",
    "去商店": "Ke Toko",
    "结账": "Bayar",
    "每月定期付款": "Pembayaran bulanan",
    "一次性付款": "Pembayaran satu kali",
    "税费": "Pajak",
    "保险费": "Biaya asuransi pengiriman",
    "运费": "Biaya Pengiriman",
    "自动-续费": "Perpanjangan otomatis",
    "免费": "Gratis",
    "今日应付总额": "Total Bayar Hari Ini",
    "点击“下订单”，即表示我同意": "Dengan mengklik \"Buat Pesanan\", saya menyetujui ",
    "服务条款和隐私政策": "Syarat Layanan dan Kebijakan Privasi",
    "下单": "Buat pesanan",
    "鉴权失败": "Otentikasi gagal",
    "恭喜！支付成功": "Selamat! Pembayaran berhasil",
    "抱歉，支付失败": "Maaf, pembayaran gagal",
    "付款时间": "Waktu pembayaran",
    "查看订单": "Lihat pesanan",
    "收货地址": "Alamat Pengiriman",
    "改变": "Ubah",
    "邮箱": "Email",
    "邮政编码": "Kode Pos",
    "送货地址第一行": "Alamat pengiriman baris 1",
    "送货地址第二行": "Alamat pengiriman baris 2",
    "可选，例如:公寓/楼栋": "Opsional, misalnya: apartemen / gedung",
    "城市": "Kota",
    "州/省": "Provinsi",
    "国家": "Negara",
    "必需的": "Wajib",
    "应用配送地址": "Gunakan alamat pengiriman",
    "支付信息": "Informasi pembayaran",
    "名字": "Nama",
    "如卡片上所示": "Sesuai yang tertera di kartu",
    "纳税人识别号/身份证号码/税务ID": "NPWP / NIK / ID Pajak",
    "电子钱包1": "eWallet",
    "卡号": "Nomor kartu",
    "安全码": "Kode Keamanan",
    "月/年": "Bulan/Tahun",
    "账单邮编/邮政编码": "Kode pos penagihan",
    "格式无效": "Format tidak valid",
    "是必需的，格式无效": " Wajib diisi, format tidak valid",
    "设为默认支付方式": "Gunakan sebagai metode pembayaran default",
    "订单大写": "Pesanan",
    "按订单号搜索": "Cari berdasarkan nomor pesanan",
    "下单时间": "Tanggal pemesanan",
    "状态": "Status",
    "商品": "Produk",
    "订单号": "Nomor pesanan",
    "快递单号": "Nomor resi",
    "预计送达时间": "Perkiraan pengiriman",
    "订单摘要": "Ringkasan Pesanan",
    "订单处理后无法更改收货地址。请在订单发货后通过追踪链接联系承运商进行调整": "Alamat pengiriman tidak dapat diubah setelah pesanan diproses. Silakan hubungi pihak pengiriman melalui tautan pelacakan setelah pesanan dikirim.",
    "订单详情": "Detail pesanan",
    "取消订单": "Batal",
    "支付": "Pembayaran",
    "支付1": "Bayar",
    "支付摘要": "Ringkasan pembayaran",
    "商品小计": "Subtotal produk",
    "订单总额": "Total pesanan",
    "关于更新订单的问题？请查看我们的": "Pertanyaan tentang pembaruan pesanan? Lihat ",
    "常见问题解答": "FAQ.",
    "男": "Pria",
    "女": "Wanita",
    "不想透露": "Tidak ingin menyebutkan",
    "第三步": "Langkah 3 dari 3",
    "邮箱链接": "Verifikasi email",
    "验证手机号码": "Verifikasi nomor ponsel",
    "发送链接邮箱1": "Kami telah mengirim email verifikasi berisi tautan ke {email}. Tautan tersebut akan kedaluwarsa dalam 24 jam. Jika Anda tidak menemukannya di kotak masuk, silakan periksa folder Sampah/Spam.",
    "发送链接邮箱2": "Jika masih belum menerima email verifikasi, klik tombol Kirim Ulang Email di bawah ini.",
    "重试": "Kirim Ulang Kode",
    "邮箱注册": "Daftar dengan alamat email",
    "60s": "Kode akan kedaluwarsa dalam 60 detik",
    "重试邮件": "KIRIM ULANG EMAIL",
    "用密码登录": "Masuk dengan kata sandi",
    "id": "ID RiSing",
    "mac地址": "Alamat MAC",
    "软件版本": "Versi perangkat lunak",
    "最后更新": "Pembaruan perangkat lunak terakhir",
    "服务位置": "Lokasi layanan",
    "总点击次数": "Total jumlah akses",
    "昵称": "Nama panggilan",
    "服务计划": "Paket layanan",
    "解绑订阅": "Lepas perangkat",
    "个人资料": "Profil",
    "通知偏好": "Preferensi notifikasi",
    "修改资料": "Edit profil",
    "电话": "Nomor Ponsel",
    "绑定mac": "Hubungkan MAC",
    "关联账户": "Hubungkan Ke Akun",
    "修改名字": "Ubah nama panggilan",
    "未激活": "Tidak aktif",
    "激活": "Aktivasi",
    "管理": "Kelola",
    "修改": "Ubah",
    "管理服务计划": "Kelola paket layanan",
    "产权激活": "Aktifkan Perangkat RiSing Anda",
    "字幕启用": "Masukkan Alamat MAC yang tercetak pada kotak produk RiSing Anda untuk mengaktifkan perangkat atau mengelola langganan Anda.",
    "Mac输入": "Alamat MAC",
    "STB激活": "Aktivasi Perangkat",
    "katalog_lagu": "Katalog Lagu",
    "catalog_hero_subtitle": "Cari lebih dari 80.000+ lagu karaoke yang tersedia di RiSing",
    "catalog_search_placeholder": "Cari berdasarkan nama artist atau lagu",
    "breadcrumb_home": "Home",
    "catalog_tab_new_song": "New Song",
    "catalog_tab_top_hits": "Top Hits",
    "catalog_heading_new_song": "Lagu Baru",
    "catalog_subheading_new_song": "Jelajahi lagu-lagu terbaru di RiSing.",
    "catalog_heading_top_hits": "Top Hits",
    "catalog_subheading_top_hits": "Jelajahi lagu-lagu terpopuler di RiSing.",
    "catalog_filter_all": "Semua",
    "catalog_filter_indonesia": "Indonesia",
    "catalog_filter_english": "English",
    "catalog_filter_korean": "Korean",
    "catalog_filter_chinese": "Chinese",
    "catalog_filter_japanese": "Japanese",
    "catalog_filter_international": "International",
    "catalog_search_results": "Search Results",
    "catalog_your_search": "Your search",
    "catalog_filter_song": "Lagu",
    "catalog_filter_artist": "Artist",
    "catalog_no_results": "Tidak ada lagu ditemukan.",
    "catalog_empty_title": "Keyword tidak ditemukan",
    "catalog_empty_desc": "Maaf, Kami belum menemukan hasil yang kamu cari. Yuk, coba kata kunci lainnya!",
    "catalog_empty_catalog_title": "Lagu tidak ditemukan",
    "catalog_empty_catalog_desc": "Maaf, belum ada lagu yang tersedia untuk kategori ini. Yuk, coba pilih kategori lainnya!",
    "catalog_empty_artist_title": "Lagu artis tidak ditemukan",
    "catalog_empty_artist_desc": "Maaf, belum ada lagu yang tersedia untuk artis ini.",
    "catalog_play_song": "Putar Lagu",
    "play_modal_title": "AKSES SEMUA LAGU RISING",
    "play_modal_desc": "Untuk menikmati lagu ini dan seluruh katalog RiSing, Anda perlu membeli produk RiSing dengan mengunjungi toko untuk melihat produk yang tersedia",
    "play_modal_cancel": "Nanti Saja",
    "play_modal_visit_shop": "Kunjungi Toko",
    "catalog_you_may_also_like": "Mungkin Anda juga menyukai...",
    "catalog_artist_songs_by": "Daftar lagu yang dipopulerkan oleh {artist}",
    "catalog_songs_count": "{count} lagu",
    "catalog_back_to_catalog": "Katalog Lagu",
    "输入MAC": "Masukkan alamat MAC karakter demi karakter persis seperti yang tercetak pada kemasan Anda.",
    "Mac输入占位符": "Masukkan Alamat MAC",
    "正在寻找一台Mac": "Cari Alamat MAC",
    "不接收消息": "Tidak Menerima Pesan? Kirim Ulang",
    "未收到验证码": "Tidak menerima Kode? Kirim Ulang Kode",
    "未收到验证码2": "Tidak menerima Kode?",
    "连接": "Hubungkan",
    "重新发送验证码3": "Kirim Ulang Kode",
    "订阅时长": "Durasi Langganan",
    "请先选择订阅时长": "Pilih durasi langganan terlebih dahulu",
    "选择您的订阅时长": "Pilih durasi langganan Anda",
    "PERBARUI LANGGANAN": "PERBARUI LANGGANAN",
    "未找到MAC地址": "Kami tidak dapat menemukan Alamat MAC yang Anda masukkan. Silakan periksa nomor yang tercetak pada produk RiSing Anda dan coba lagi.",
    "注册设备": "Daftarkan Perangkat Anda",
    "注册字幕设备": "Perangkat ini belum terhubung ke akun. Tambahkan detail profile untuk mengaktifkannya.",
    "账户类型": "Jenis Akun",
    "选择账户类型": "Pilih Jenis Akun",
    "电子邮件/电话": "Email/No Telfon",
    "电子邮件/电话占位符": "Masukkan email/No Telfon",
    "填写表格": "Isi form terlebih dahulu",
    "地址": "Alamat Pengiriman",
    "支付方式": "Cara Pembayaran",
    "修改信息": "Edit Profil",
    "取消自动续费": "Batalkan Perpanjangan Otomatis",
    "改变计划": "Ubah Paket",
    "您确定要更改计划吗": "Apakah Anda yakin ingin mengubah paket?",
    "您确定要启用自动续订吗": "Apakah Anda yakin ingin mengaktifkan perpanjangan otomatis?",
    "确认取消自动续费吗,取消后，将在下个月停止自动续费": "Apakah Anda yakin ingin membatalkan perpanjangan otomatis? Manfaat langganan Anda saat ini tetap berlaku, dan perpanjangan otomatis akan dihentikan pada siklus penagihan berikutnya.",
    "您确定要取消自动续订功能吗": "Apakah Anda yakin ingin membatalkan perpanjangan otomatis ?",
    "取消后，自动续订功能将停止，您的会员资格将于失效": "Setelah pembatalan, pembayaran otomatis akan berhenti, dan keanggotaan Anda akan berakhir pada",
    "服务将于更改": "Layanan akan berubah pada",
    "您将被收取的费用": "dan Anda akan dikenakan biaya IDR",
    "今天": "hari ini.",
    "您的新月度服务价格为": "Harga layanan bulanan baru Anda adalah",
    "并将于开票": "dan akan ditagihkan pada",
    "提交": "Konfirmasi",
    "选择确认即表示您承认并同意适用的条款和条件": "Dengan memilih Konfirmasi, Anda mengakui dan menyetujui syarat dan ketentuan yang berlaku.",
    "启用自动续订": "Aktifkan perpanjangan otomatis untuk melanjutkan langganan streaming bulanan Anda sebesar ",
    "订阅月": "per bulan.",
    "您想激活它吗": "Apakah Anda ingin mengaktifkannya?",
    "您的服务计划": "Paket Layanan Anda",
    "可用服务计划": "Paket Layanan Tersedia",
    "自动续费": "Perpanjang Otomatis",
    "!自动续费": "Tidak Perpanjang Otomatis",
    "请输入密码": "Silakan masukkan kata sandi",
    "请再次输入密码": "Silakan masukkan kata sandi lagi",
    "两次输入密码不一致!": "Kata sandi tidak cocok. Silakan masukkan ulang",
    "密码校验": "Minimal 8 karakter alfanumerik, termasuk 1 huruf kapital dan 1 karakter khusus",
    "身份证": "Nomor Identitas",
    "邮编": "Kode Pos",
    "计费大写": "PENAGIHAN",
    "管理您的发票和付款": "Kelola invoice dan pembayaran Anda",
    "发票": "Invoice",
    "按发票号码搜索": "Cari berdasarkan nomor invoice",
    "日期": "Tanggal",
    "备注": "Deskripsi",
    "发票号码": "Nomor Invoice",
    "方法": "Metode",
    "总计": "Total",
    "市区": "Provinsi",
    "具体地址1": "Alamat Pengiriman Baris 1",
    "具体地址2": "Alamat Pengiriman Baris 2",
    "名": "Nama Depan",
    "姓名2": "Nama Lengkap",
    "名银行": "Nama Depan (sesuai kartu)",
    "姓银行": "Nama Belakang (sesuai kartu)",
    "姓": "Nama Belakang",
    "复制成功": "Berhasil disalin",
    "在家唱卡拉OK": "KARAOKE DI RUMAH,",
    "暂时": "UNTUK MOMEN",
    "哪个更令人兴奋": "YANG LEBIH SERU",
    "卡拉": "KARAOKE",
    "一起": "BERSAMA",
    "在家": "DI RUMAH",
    "任何地点": "DI MANA SAJA",
    "在我们的应用程序中查找您最喜欢的歌曲": "Temukan lagu favorit Anda di aplikasi kami",
    "家庭卡拉OK娱乐，每天仅需5000印尼盾": "Home Karaoke Entertainment cukup Rp 5.000 per hari",
    "现在开始唱歌": "Mulai Bernyanyi Sekarang",
    "免费唱歌一个月": "Bernyanyi Gratis Sebulan",
    "联系我们": "Hubungi Kami",
    "我们的位置": "Lokasi Kami",
    "特征": "Fitur",
    "下载应用程序": "Unduh Aplikasi Rising",
    "找到我们": "Temukan Kami",
    "跟着我们": "Ikuti Kami",
    "VISITHAPPY": "RiSing © 2026 RiSing adalah bagian dari Happy Puppy Group. Kunjungi kami di ",
    "使用密码登录": "Masuk dengan kata sandi",
    "点击链接登录": "Masuk tanpa kata sandi",
    "信用卡": "Kartu Debit / Kredit",
    "每一刻都闪耀着光芒": "dan setiap momen bersinar",
    "一起在音乐中": "bersama dalam musik",
    "从麦克风到魔术，每个声音都有自己的位置": "Dari mikrofon hingga keajaiban, setiap suara menemukan tempatnya,",
    "拿起麦克风，像明星一样歌唱吧": "Ambil mic, dan bernyanyi seperti bintang!",
    "尽情享受卡拉OK吧": "NIKMATI KARAOKE SEPUASNYA",
    "向世界展示自己": "Tunjukkan dirimu kepada dunia",
    "通过你唱的歌": "melalui lagu yang kamu nyanyikan",
    "选择你喜欢的流派并创作": "Pilih genre yang kamu sukai dan ciptakan",
    "播放列表，显示你的共鸣": "playlist yang mencerminkan vibe-mu.",
    "每一个相聚的瞬间，": "TIAP MOMEN KEBERSAMAAN,",
    "卡拉OK更有趣": "MAKIN SERU DENGAN KARAOKE",
    "你最喜欢的": "FAVORITMU",
    "歌在这里等着你": "LAGU MENUNGGUMU DI SINI",
    "享受音乐的新方式": "CARA BARU MENIKMATI MUSIK",

    "享受音乐的新方式2": "CARA BARU MENIKMATI KARAOKE DI RUMAH",
    "在家唱卡拉OK": "KARAOKE DI RUMAH",
    "客户评价": "APA KATA PELANGGAN KAMI",
    "ENTERTAINMENTKARAOKE": "All-in-One Home Karaoke Entertainment​",
    "ENTERTAINMENTKARAOKE2": "All-in-One Home Entertainment Karaoke by Happy Puppy Group​​",
    "ENTERTAINMENTKARAOKESUB": "Karaoke Seru dan Sepuasnya di Rumah",
    "RISINGSTB": "RiSing KARAOKE SET-TOP BOX",
    "RISINGSTBSUB": "Alat karaoke portable yang berisi 80.000+ lagu karaoke by Happy Puppy",
    "RISINGCONSOLE": "RiSing CONSOLE ONE",
    "RISINGCONSOLESUB": "Powerfull speaker dengan built-in karaoke dan mic wireless",
    "大家起唱卡拉OK更有趣": "KARAOKE LEBIH SERU BERSAMA",
    "大家起唱卡拉OK更有趣SUB": "Bernyanyi bersama keluarga, teman atau rekan kerja kapan saja dan dimana saja",

    "就是用你的声音让它变得生动起来": "adalah menghidupkannya dengan suaramu",
    "与我们一起度过难忘的歌唱体验": "PENGALAMAN BERNYANYI TAK TERLUPAKAN BERSAMA KAMI",
    "做好充分准备": "BERSIAPLAH UNTUK YANG PALING",
    "随时随地享受娱乐": "NIKMATI HIBURAN KAPAN SAJA,",
    "不离开家": "TANPA KELUAR RUMAH",
    "本月订阅优惠尽享最优": "Dapatkan penawaran terbaik untuk langganan bulan ini",
    "每月": "Bulanan",
    "年度的": "Tahunan",
    "入门包": "Starter Pack",
    "RISING Player（家用卡拉OK设备）": "RiSing Karaoke Set-Top Box (Alat Karaoke di rumah)",
    "免费试用 30 天": "Akses Langganan Karaoke 30 Hari + GRATIS Tambahan 60 Hari!",
    "月": "bulan",
    "季度": "Triwulanan",
    "条款和条件": "Syarat & Ketentuan",
    "下个月的订阅费为每月 150,000 印尼盾。": "Biaya langganan Rp 150.000 per bulan untuk bulan berikutnya",
    "隐私政策": "Kebijakan Privasi",
    "自信的表达": "EKSPRESI PENUH PERCAYA DIRI",
    "就在家": "CUKUP DARI RUMAH SAJA",
    "尽情歌唱": "NYANYIKAN SEPENUH HATI",
    "大声唱吧": "NYANYI SEKERAS MUNGKIN",
    "税号": "NPWP / NIK / ID Kartu",
    "增加": "Tambah",
    "删除": "Hapus",
    "戴上它，开始唱歌吧": "TINGGAL PASANG & MULAI BERNYANYI",
    "安装简便，仅需1分钟": "INSTALASI MUDAH HANYA 1 MENIT",
    "收录超过 80,000 首最新歌曲": "KOLEKSI 80.000+ LAGU TERUPDATE",
    "本地及国际歌单": "PLAYLIST LOKAL & MANCANEGARA",
    "电子钱包": "E-wallet",
    "修改邮箱": "Ubah email",
    "修改手机号": "Ubah nomor ponsel",
    "确认邮箱": "Konfirmasi email",
    "确认手机号": "Konfirmasi nomor ponsel",
    "绑定成功": "Berhasil ditautkan",
    "通知首选项": "Preferensi Notifikasi",
    "选择要接收的通知": "Pilih notifikasi yang ingin Anda terima. Anda mungkin masih menerima notifikasi setelah memilih keluar",
    "营销": "Pemasaran",
    "感兴趣的新闻": "Berita dan pembaruan RiSing yang mungkin menarik bagi Anda",
    "订阅发票": "Faktur langganan dan pesanan, konfirmasi pembayaran, serta notifikasi penagihan lainnya",
    "订单运输": "Pesanan dan pengiriman",
    "发货通知": "Terima notifikasi saat pesanan dibuat, dikirim, atau diubah",
    "支持": "Dukungan",
    "新活动通知": "Terima notifikasi untuk aktivitas baru pada pesan dukungan",
    "SMS": "SMS",
    "支持中心": "Pusat Dukungan",
    "我们能帮你什么": "APA YANG BISA KAMI BANTU?",
    "回首页": "Beranda",
    "让我们知道这是否有帮助": "Beri tahu kami apakah ini membantu",
    "是": "Ya",
    "否": "Tidak",
    "邮箱必填": "Alamat email wajib diisi",
    "手机号必填": "Nomor ponsel wajib diisi",
    "必须勾选": "Dengan mendaftar, saya menyetujui ",
    "服务条款": " Syarat Layanan ",
    "隐私协议": " Kebijakan Privasi ",
    "和": "dan",
    "请输入正确的格式": "Silakan masukkan format yang benar",
    "请输入首名字": "Silakan masukkan nama depan",
    "请输入尾名字": "Silakan masukkan nama belakang",
    "请勾选服务条款": "Silakan setujui syarat layanan dan kebijakan privasi",
    "保存成功": "Berhasil disimpan",
    "预览": "Pratinjau",
    "请输入地址": "Silakan masukkan alamat",
    "请输入邮编": "Silakan masukkan kode pos",
    "请输入邮箱": "Silakan masukkan alamat email",
    "请输入手机号": "Silakan masukkan nomor ponsel",
    "请输入证件号码及上传证件图片": "Masukkan nomor dokumen",
    "使用默认支付方式": "Gunakan sebagai metode pembayaran default",
    "提示": "Tips",
    "确认是否删除": "Apakah Anda yakin ingin menghapus metode pembayaran ini? Perpanjangan otomatis dapat gagal jika masih aktif",
    "请先完善个人信息": "Silakan lengkapi informasi pribadi Anda terlebih dahulu",
    "修改成功": "Berhasil diperbarui",
    "请前往个人中心保存手机号": "Silakan ke Pusat Pribadi untuk menyimpan nomor HP",
    "请前往个人中心保存邮箱": "Silakan ke Pusat Pribadi untuk menyimpan email",
    "邮箱勾选提示": "Anda akan menerima email tentang {category} ke depannya.",
    "短信勾选提示": "Anda akan menerima SMS tentang {category} ke depannya.",
    "邮箱取消提示": "Anda tidak akan lagi menerima email tentang {category}.",
    "短信取消提示": "Anda tidak akan lagi menerima SMS tentang {category}.",
    "添加支付方式": "Tambah Metode Pembayaran",
    "主动计划": "Paket aktif",
    "订阅计划链接跳转": "Syarat Layanan",
    "暂无数据": "Tidak ada data tersedia",
    "请选择": "Silakan pilih",
    "请选择服务计划": "Silakan pilih paket layanan",
    "30天活跃订阅": "Langganan Aktif 30 Hari",
    "90天活跃订阅": "Langganan Aktif 90 Hari",
    "访问80000多首卡拉OK歌曲": "Akses ke 80.000+ Lagu Karaoke.",
    "无广告歌唱不受干扰": "Tanpa Iklan, Bernyanyi Tanpa Gangguan.",
    "随时取消": "Batalkan kapan saja.",
    "请修改您的头像": "Silakan ubah avatar Anda",
    "忘记密码": "Lupa kata sandi?",
    "发送重置链接": "Kirim tautan reset",
    "创建账号": "Buat akun baru",
    "返回登录": "Kembali ke Login",
    "链接已发送": "Kami mendapatkannya",
    "订阅编号": "Nomor Langganan",
    "订阅计划名称": "Nama Paket Layanan",
    "查看订阅历史": "Lihat Riwayat Langganan",
    "不续费": "Tidak Perpanjangan",
    "零售支付": "Pembayaran Retail",
    "二维码支付2": "Pembayaran QRIS",
    "支付代码": "Kode Pembayaran",
    "已逾期": "Kadaluarsa",
    "支付状态": "Status Pembayaran",
    "支付成功": "Pembayaran Berhasil",
    "支付失败": "Pembayaran Gagal",
    "请重新尝试支付": "Silakan coba pembayaran lagi.",
    "付款已取消": "Pembayaran Dibatalkan",
    "付款取消说明": "Pembayaran dibatalkan dan pesanan belum diproses. Silahkan lakukan pemesanan ulang atau hubungi admin untuk bantuan.",
    "支付超时": "Waktu Pembayaran Habis",
    "付款链接已过期。": "Link pembayaran sudah kedaluwarsa. Silakan buat pesanan baru untuk melanjutkan pembayaran dengan menghubungi admin.",
    "付款成功": "Selamat Pembayaran berhasil",
    "付款成功详情": "Langganan RiSing kamu sudah aktif. Nikmati seluruh fitur karaoke dan pengalaman bernyanyi tanpa batas.",
    "取消账单": "Batalkan Tagihan",
    "确认取消该账单？": "Apakah Anda yakin ingin membatalkan tagihan ini?",
    "正在处理": "Sedang diproses",
    "取消成功": "Berhasil dibatalkan",
    "取消失败": "Gagal membatalkan",
    "银行虚拟账户": "Virtual Account",
    "二维码支付": "QRIS",
    "零售": "Retail",
    "银行虚拟账户付款": "Pembayaran Akun Virtual",
    "总付款": "Total Pembayaran",
    "在...内支付": "Bayar Dalam",
    "虚拟账户": "Virtual Account",
    "截止日期": "Jatuh Tempo",
    "请选择支付方式": "Silakan pilih metode pembayaran",
    "正在确认支付结果": "Mengkonfirmasi hasil pembayaran",
    "电子钱包支付": "Pembayaran E-Wallet",
    "继续通过手机进行支付": "Lanjutkan pembayaran Anda di ponsel",
    "详情": "Detail",
    "支付详情": "Detail Pembayaran",
    "时": "Jam",
    "分": "Menit",
    "秒": "Detik",
    "订阅历史": "Riwayat Langganan",
    "退款政策": "Syarat & Ketentuan",
    "正在处理支付": "Memproses Pembayaran",
    "账单信息异常": "Informasi tagihan tidak normal",
    "区域": "Kecamatan",
    "街道": "Kelurahan",
    "默认": "Default",
    "添加新卡并订阅": "Tambahkan kartu baru dan berlangganan",
    "请选择district": "Silakan pilih district",
    "请选择subdistrict": "Silakan pilih subdistrict",
    "选择信用卡": "Pilih Kartu Kredit",
    "新增信用卡": "Tambahkan kartu baru",
    "新增信用卡并支付": "Tambahkan Kartu Baru",
    "只有支付1": "Tambahkan Kartu Baru",
    "只有支付2": "Tambahkan Kartu Baru",
    "鉴权失败，请重试": "Autentikasi gagal, silakan coba lagi",
    "支付方式添加成功": "Metode pembayaran berhasil ditambahkan",
    "下载失败，请稍后重试": "Gagal mengunduh, silakan coba lagi nanti",
    "PDF 下载成功": "PDF berhasil diunduh",
    "PDF 文件不存在": "File PDF tidak ditemukan",
    "家庭使用": "peruntukan rumah, personal, dan non-komersial.",
    "忘记密码手机": "Lupa kata sandi?",
    "请先输入手机号": "Silakan masukkan nomor ponsel Anda terlebih dahulu.",
    "手机号未注册": "Nomor ponsel ini tidak terdaftar. Silakan daftar.",
    "验证码说明": "Masukkan kode 6 digit yang dikirim ke Anda di {phone}",
    "请输入我们发送到您手机号码的6位验证码。": "Masukan kode 6 digit yang telah kami kirimkan ke Nomor Ponsel kamu",
    "重新发送验证码": "KIRIM ULANG KODE",
    "重新发送验证码2": "Kirim Ulang OTP",
    "继续重置": "lanjutkan reset",
    "验证码错误": "Kode verifikasi tidak valid. Silakan periksa dan coba lagi.",
    "验证码已过期": "Kode verifikasi ini telah kedaluwarsa. Silakan kirim ulang kode.",
    "新密码": "Kata sandi baru",
    "密码格式无效": "Minimal 8 digit alfanumerik, termasuk 1 huruf kapital dan 1 karakter khusus",
    "两次密码不一致": "Kata sandi tidak cocok. Silakan masukkan ulang.",
    "新密码不能与旧密码相同": "Kata sandi baru tidak boleh sama dengan kata sandi lama.",
    "密码更新完成": "Kata Sandi Berhasil Diperbarui!",
    "创建新密码": "Buat kata sandi baru",
    "订阅类型": "Pembaruan Otomatis",
    "发送链接邮箱3": "Kami telah mengirimkan tautan reset kata sandi ke {email}. Ketuk tautan untuk mengatur ulang kata sandi Anda.",
    "已向以下邮箱发送验证邮件：": "Email verifikasi telah dikirim ke {email}.",
    "确定": "OK",
    "确认": "Konfirmasi",
    "账户删除正在进行中": "Penghapusan Akun Sedang Berlangsung",
    "取消删除账户": "Batalkan Hapus Akun",
    "删除账户": "Hapus Akun",
    "确认删除账户": "Konfirmasi Penghapusan Akun",
    "若继续，则表示您请求删除您的账户": "Dengan melanjutkan, Anda meminta penghapusan akun Anda.",
    "特此通知": "Harap diperhatikan bahwa",
    "您可在提交后7天内取消此请求": "Anda dapat membatalkan permintaan ini dalam waktu 7 hari sejak pengajuan",
    "在7天的待处理期间，您的账户将保持活跃状态": "Akun Anda akan tetap aktif selama periode penundaan 7 hari",
    "您的账户状态将显示正在进行删除操作": "Status akun Anda akan menunjukkan bahwa penghapusan sedang berlangsung",
    "一旦永久删除，您的注册邮箱地址或电话号码可能会在14天后被用于创建新账户": "Setelah dihapus secara permanen, alamat email atau nomor telepon terdaftar Anda dapat digunakan untuk membuat akun baru setelah 14 hari.",
    "7天期限过后，此操作将不可撤销": "Setelah periode 7 hari berlalu, tindakan ini tidak dapat dibatalkan.",
    "删除请求已提交": "Permintaan Penghapusan Berhasil Diajukan",
    "您的账户删除请求已成功提交": "Permintaan penghapusan akun Anda telah berhasil diajukan.",
    "您的账户将在接下来的7天内保持活跃状态。在此期间": "Akun Anda akan tetap aktif selama 7 hari ke depan. Selama periode ini:",
    "您可以随时取消删除请求": "Anda dapat membatalkan penghapusan kapan saja.",
    "您的账户将显示一则通知，表明正在进行删除操作": "Akun Anda akan menampilkan pemberitahuan yang menunjukkan bahwa penghapusan sedang berlangsung.",
    "如果请求在7天内未被取消，您的账户将被永久删除": "Jika permintaan tidak dibatalkan dalam waktu 7 hari, akun Anda akan dihapus secara permanen.",
    "永久删除后": "Setelah penghapusan permanen",
    "14天后，您可以使用您的电子邮件地址或电话号码重新注册": "alamat email atau nomor telepon Anda dapat digunakan untuk mendaftar kembali setelah 14 hari.",
    "确认取消账户删除": "Konfirmasi Batalkan Penghapusan Akun",
    "通过处理，您请求取消/删除您的账户": "Dengan memproses permintaan ini, Anda menyatakan ingin membatalkan atau menghapus akun Anda.",
    "成功取消账户删除": "Berhasil Batalkan Penghapusan Akun",
    "账户删除取消已成功": "Pembatalan untuk penghapusan akun telah berhasil.",
    "享受使用RiSing的乐趣": "Selamat menggunakan RiSing",
    "在账户删除冷静期内，无法进行支付": "Pembayaran tidak tersedia selama periode pendinginan penghapusan akun.",
    "印度尼西亚排名第一的家庭娱乐卡拉OK": "#1 HOME-ENTERTAIMENT KARAOKE DI INDONESIA",
    "在家唱歌，也能成为明星": "Nyanyi dari rumah dan jadi bintang",
    "开始唱歌": "Mulai Bernyanyi",
    "快乐小狗集团旗下成员": "Bagian Dari Happy Puppy Group",
    "获得官方音乐授权支持": "Didukung oleh lisensi musik resmi melalui",
    "RISING 以全新方式呈现": "RiSing HADIR DENGAN CARA BARU",
    "在家享受卡拉OK": "MENIKMATI KARAOKE DARI RUMAH",
    "RiSing 拥有全面合法的歌曲库，为任何人提供了一个表达自我、释放情感、与亲近之人一起享受歌唱乐趣的空间。": "Dengan katalog lagu yang lengkap dan legal, RiSing menghadirkan ruang bagi siapapun untuk mengekspresikan diri, melepas emosi, dan menikmati momen bernyanyi bersama orang terdekat.",
    "在家卡拉OK所需的一切": "SEMUA YANG KAMU BUTUHKAN UNTUK KARAOKE DI RUMAH",
    "功能滑块1": "Mulai karaoke dalam hitungan detik",
    "功能滑块2": "Akses 80.000+ lagu karaoke yang lengkap dan terus bertambah​",
    "功能滑块3": "Pilih cara berkaraoke, dengan atau tanpa vokal penyanyi​",
    "功能滑块4": "Karaoke sepuasnya tanpa batas cuma Rp 5.000 per hari​",
    "试用3个月，费用为999,000印尼盾": "Coba 3 bulan seharga Rp999.000",
    "查看所有计划": "Lihat semua paket",
    "特别新手包售价 999,000 印尼盾，包含 Rising Player 和 3 个月的订阅服务。": "Khusus Starter Pack Rp 999.000 mendapatkan RiSing Player dan berlangganan 3 bulan, lalu",
    "此后每月150,000印尼盾。": "Rp150.000 per bulan sesudahnya.",
    "播放列表": "Playlist",
    "播放列表描述": "Cari lagu favoritmu dengan mudah dan buat playlist sendiri",
    "新歌": "New Song",
    "新歌描述": "Temukan lagu-lagu yang baru ditambahkan​",
    "历史": "History",
    "历史描述": "Jelajahi lagu-lagu yang sedang populer",
    "热门点击": "Top Hits",
    "热门点击描述": "Lihat lagu-lagu yang paling sering dinyanyikan dan sedang populer",
    "流派": "Genre",
    "流派描述": "Temukan lagu berdasarkan genre favoritmu",
    "玩家": "Player",
    "玩家描述": "Atur dan nikmati lagu yang sedang kamu nyanyikan",
    "队列": "Queue",
    "队列描述": "Tambahkan lagu berikutnya ke daftar antrean nyanyimu",
    "因为卡拉OK和大家一起更有趣": "KARENA KARAOKE SELALU LEBIH SERU BERSAMA",
    "家庭卡拉OK": "Karaoke Keluarga",
    "与朋友同乐": "Bersama Teman",
    "下班后聚会": "After Office",
    "独自的": "Sendirian",
    "准备好在家卡拉OK了吗？": "SIAP MULAI KARAOKE DARI RUMAH?",
    "RiSing让卡拉OK变得更简单、方便、实惠。": "RiSing membuat karaoke jadi lebih mudah, praktis, dan terjangkau.",
    "RiSing新手套装RTX3M206SPH（家庭、个人及非商业用途）": "RiSing STARTER PACK RTX3M206 SPH (PERUNTUKAN RUMAH, PERSONAL, DAN NON-KOMERSIAL)",
    "售价999000印尼盾": "Rp999.000",
    "原价1250000印尼盾": "Rp 1.300.000",
    "折扣17%": "23,15%",
    "RiSing播放器（家用卡拉OK设备）": "RiSing Karaoke Set-Top Box (Alat Karaoke di rumah)",
    "订阅卡拉OK30天+免费额外60天！": "Bebas nyanyi 90 hari",
    "访问80000首以上卡拉OK歌曲": "Akses ke 80.000+ Lagu Karaoke.",
    "无广告，畅唱无阻": "Tanpa Iklan. Bernyanyi Tanpa Gangguan.",
    "随时可取消": "Batalkan kapan saja.",
    "立即开始唱歌": "Mulai Bernyanyi Sekarang",
    "次月起每月订阅费用150000印尼盾": "Biaya langganan Rp 150.000 per bulan untuk bulan berikutnya",
    "关于我们": "Tentang Kami",
    "买": "Beli",
    "行动": "Aksi",
    "英雄标语": "NYANYI DAN BERSINAR DARI RUMAH",
    "关于我们标题": "DI RiSing,<br>KAMI PERCAYA BERNYANYI ADALAH BENTUK EKSPRESI DIRI.",
    "关于我们段落一": "Berawal dari pengalaman Happy Puppy menghadirkan karaoke keluarga di seluruh Indonesia, RiSing membawa karaoke ke era baru, dari ruang publik ke ruang pribadi, dari fisik ke digital, dan dari statis menjadi on-demand.",
    "关于我们段落二": "Kini, siapa pun bisa bernyanyi, mengekspresikan diri, dan menikmati kegembiraan karaoke kapan saja di rumah.",
    "关于我们徽章文字": "Dengan katalog lagu legal yang mendukung karya musisi lokal, bekerja sama dengan ASIRINDO (Asosiasi Industri Rekaman Indonesia)",
    "精彩时刻标题": "MOMENT BEBASKAN SUARA",
    "时刻说明一": "Saat keluarga berkumpul dan lagu favorit mulai dimainkan.",
    "时刻说明二": "Saat merayakan ulang tahun bersama orang terdekat.",
    "时刻说明三": "Saat teman-teman ikut bernyanyi tanpa malu.",
    "时刻说明四": "Saat melepas penat setelah hari kerja yang panjang.",
    "第五矩的描述": "Saat nostalgia muncul dari lagu lama yang tiba-tiba diputar.",
    "第六时刻的描述": "Saat rumah terasa seperti ruang karaoke pribadi.",
    "旅程标题": "LANGKAH BESAR<br>PERJALANAN KAMI",
    "里程碑2026": "RiSing hadir, membawa karaoke ke rumah dan membuka era baru bernyanyi.",
    "里程碑2022": "Happy Puppy berkembang menjadi lebih dari 73 outlet di 46 kota di Indonesia.",
    "里程碑2004": "MURI menobatkan Happy Puppy sebagai karaoke keluarga pertama di Indonesia.",
    "里程碑1992": "Happy Puppy memperkenalkan konsep karaoke keluarga di Indonesia.",
    "STB图片描述": "RiSing STB",
    "STB右侧图片描述": "Semua Bisa Jadi Bintang",
    "购物车标题": "BAYAR",
    "返回": "Kembali",
    "更改": "Ubah",
    "手机号码": "No. HP",
    "手机号码错误提示": "No. HP wajib diisi dan format tidak valid",
    "电子邮件": "Email",
    "电子邮件错误提示": "Email wajib diisi dan format tidak valid",
    "邮政编码错误提示": "Kode Pos wajib diisi",
    "省份": "Provinsi",
    "区县": "Kecamatan",
    "区县错误提示": "Kecamatan wajib diisi",
    "村庄": "Kelurahan",
    "村庄错误提示": "Kelurahan wajib diisi",
    "地址行1": "Alamat Baris 1",
    "地址错误提示": "Alamat wajib diisi",
    "地址行2": "Alamat Baris 2",
    "可选": "opsional",
    "保存地址": "Simpan Alamat",
    "订单标签": "PESANAN",
    "损坏保护": "Proteksi Kerusakan",
    "配送选项": "Opsi Pengiriman",
    "快递类型常规": "Reguler",
    "预计到达": "Estimasi Tiba",
    "天": "Hari",
    "付款信息": "Informasi Pembayaran",
    "信用借记卡": "Kartu Kredit / Debit",
    "信用卡提示": "Detail kartu kredit muncul setelah \"Buat Pesanan\".",
    "总价格": "Total Harga",
    "产品": "Produk",
    "总损坏保护": "Total Proteksi Kerusakan",
    "服务费": "Biaya Layanan",
    "创建订单": "Buat Pesanan",
    "同意条款说明": "Dengan menekan \"Buat Pesanan\", Anda menyetujui syarat & ketentuan serta kebijakan privasi.",
    "购物车为空": "Keranjang belanja Anda kosong.",
    "付款状态": "Status Pembayaran",
    "付款倒计时": "Bayar Dalam",
    "已过期": "Kedaluwarsa",
    "截止时间": "Batas waktu",
    "电子钱包提示": "Lanjutkan pembayaran melalui aplikasi di ponsel Anda.",
    "付款码": "Kode Bayar",
    "虚拟账户号码": "Nomor Virtual Account",
    "QRIS付款": "Pembayaran QRIS",
    "二维码": "QR Code",
    "信用卡付款": "Pembayaran Kartu Kredit",
    "添加新卡并付款": "Tambah Kartu Baru & Bayar",
    "用新卡付款": "Bayar dengan Kartu Baru",
    "设为默认付款方式": "Jadikan metode pembayaran default",
    "付款": "Bayar",
    "电子钱包付款": "Pembayaran E-Wallet",
    "零售付款": "Pembayaran Retail",
    "虚拟账户付款": "Pembayaran Virtual Account",
    "自提门店": "Ambil di Outlet",
    "自提说明": "Ambil langsung di toko kami",
    "门店名称": "Outlet Utama - Jakarta Selatan",
    "门店地址": "Jl. Sudirman No. 123, Kebayoran Baru, Jakarta Selatan 12190",
    "营业时间": "Senin – Sabtu: 09.00 – 18.00 WIB",
    "自提节省说明": "Anda hemat ongkir & biaya asuransi d搜索ngan ambil di outlet!",
    "新闻": "Berita",
    "回到新闻": "Kembali ke berita",
    "经过": "Oleh",
    "最新文章": "POSTINGAN TERBARU",
    "了解更多": "Pelajari Selengkapnya",
    "暂无文章": "Belum ada berita untuk kategori ini.",
    "其他文章": "Jelajahi Berita Lainnya",
    "查看全部": "Lihat Semuanya",
    "收起": "Lihat Lebih Sedikit",
    "搜索": "Temukan Berita Favoritmu",
    "全部": "Semua",
    "活动": "Event",
    "故事": "Cerita",
    "文章一标题": "Now Playing: RiSing",
    "文章一描述": "Still can't move on dari RiSing's Press Conference! Yuk, nantikan official launch dari RiSing di 25 Maret 2026, ya! ✨",
    "文章二标题": "RiSing Bagi Bagi",
    "文章二描述": "Counting down! Sebentar lagi RiSing hadir di rumah kalian ✨",
    "文章三标题": "Lorem Ipsum Skavazio",
    "文章三描述": "Lorem Ipsum Skavazio",
    "验证失败": "Verifikasi Gagal!",
    "链接无效或已过期。": "Tautan tidak valid atau sudah kedaluwarsa.",
    "链接失效": "Ups! Tautan reset ini sudah kedaluwarsa.",
    "优惠券": "PROMO",
    "使用促销代码": "Pakai kode promo",
    "促销代码": "Kode Promo",
    "输入促销代码": "Masukan Kode Promo",
    "例如：RIS134": "Contoh : RIS134",
    "申请促销": "Terapkan Promo",
    "必须填写促销代码": "Kode promo wajib diisi",
    "已应用促销代码": "Kode promo berhasil diterapkan",
    "您输入的优惠码不正确": "Kode promo yang Anda masukkan tidak valid",
    "促销代码验证失败": "Gagal memverifikasi kode promo. Silakan coba lagi.",
    "促销代码已取消": "Kode promo berhasil dibatalkan",
    "使用": "Pakai",
    "直到": "Hingga",
    "家": "Home",
    "店铺": "Toko",
    "链接设备": "Tautkan Perangkat",
    "之前付款": "Bayar Sebelum",
    "扫描二维码": "Pindai QR Code",
    "下载二维码": "Unduh QR Code",
    "账单总额": "Total Tagihan",
    "返回首页": "Ke Beranda",
    "立即支付": "Bayar Sekarang",
    "检查付款状态": "Cek Status Bayar",
    "支付说明": "Instruksi Pembayaran",
    "打开您的电子钱包或手机银行应用": "Buka aplikasi dompet digital atau mobile banking Anda",
    "选择扫码 / QRIS 菜单": "Pilih menu Scan QR / QRIS",
    "扫描上方二维码": "Scan QR Code di atas",
    "检查付款详情并确认": "Periksa detail pembayaran dan konfirmasi",
    "支付完成": "Pembayaran selesai",
    "ATM BCA": "ATM BCA",
    "ATM BCA 步骤1": "Masukkan kartu ATM BCA & PIN Anda.",
    "ATM BCA 步骤2": "Pilih menu Transaksi Lainnya → Transfer.",
    "ATM BCA 步骤3": "Pilih ke Rekening BCA Virtual Account.",
    "ATM BCA 步骤4": "Masukkan nomor Virtual Account yang tertera.",
    "ATM BCA 步骤5": "Pastikan nama & jumlah tagihan sudah benar, lalu konfirmasi.",
    "ATM BCA 步骤6": "Transaksi selesai, simpan bukti pembayaran.",
    "m-BCA (BCA Mobile)": "m-BCA (BCA Mobile)",
    "m-BCA 步骤1": "Login m-BCA dengan kode akses Anda.",
    "m-BCA 步骤2": "Pilih m-Transfer → BCA Virtual Account.",
    "m-BCA 步骤3": "Masukkan nomor Virtual Account.",
    "m-BCA 步骤4": "Periksa informasi pembayaran, lalu tekan OK.",
    "m-BCA 步骤5": "Masukkan PIN m-BCA untuk konfirmasi.",
    "m-BCA 步骤6": "Transaksi berhasil, cek notifikasi.",
    "网银BCA": "Internet Banking BCA",
    "网银BCA 步骤1": "Login ke klikbca.com.",
    "网银BCA 步骤2": "Pilih Transfer Dana → Transfer ke BCA Virtual Account.",
    "网银BCA 步骤3": "Masukkan nomor Virtual Account.",
    "网银BCA 步骤4": "Periksa detail & jumlah, lalu klik Lanjutkan.",
    "网银BCA 步骤5": "Masukkan respon KeyBCA untuk otorisasi.",
    "网银BCA 步骤6": "Pembayaran berhasil.",
    "ATM bjb": "ATM bjb",
    "ATM bjb 步骤1": "Masukkan kartu ATM bjb & PIN.",
    "ATM bjb 步骤2": "Pilih Transaksi → Pembayaran → Lainnya.",
    "ATM bjb 步骤3": "Pilih Virtual Account.",
    "ATM bjb 步骤4": "Masukkan nomor Virtual Account.",
    "ATM bjb 步骤5": "Konfirmasi nama & nominal, lalu tekan OK.",
    "手机银行bjb DIGI": "Mobile Banking bjb DIGI",
    "手机银行bjb DIGI 步骤1": "Login bjb DIGI.",
    "手机银行bjb DIGI 步骤2": "Pilih Pembayaran → Virtual Account.",
    "手机银行bjb DIGI 步骤3": "Input nomor Virtual Account.",
    "手机银行bjb DIGI 步骤4": "Periksa detail, masukkan PIN, konfirmasi.",
    "网银bjb": "Internet Banking bjb",
    "网银bjb 步骤1": "Login ib.bankbjb.co.id.",
    "网银bjb 步骤2": "Pilih Pembayaran → Virtual Account.",
    "网银bjb 步骤3": "Masukkan nomor Virtual Account.",
    "网银bjb 步骤4": "Konfirmasi dengan token/OTP.",
    "验证码已发送": "KODE OTP TELAH DIKIRIM",
    "NEO+应用 (BNC)": "Aplikasi NEO+ (BNC)",
    "NEO+ 步骤1": "Login ke aplikasi NEO+.",
    "NEO+ 步骤2": "Pilih Transfer → Virtual Account.",
    "NEO+ 步骤3": "Masukkan nomor Virtual Account.",
    "NEO+ 步骤4": "Cek detail & nominal, masukkan PIN.",
    "NEO+ 步骤5": "Transaksi selesai.",
    "ATM BNI": "ATM BNI",
    "ATM BNI 步骤1": "Masukkan kartu ATM BNI & PIN.",
    "ATM BNI 步骤2": "Pilih Menu Lain → Transfer → Rekening Tabungan.",
    "ATM BNI 步骤3": "Pilih Ke Rekening BNI.",
    "ATM BNI 步骤4": "Masukkan nomor Virtual Account (16 digit).",
    "ATM BNI 步骤5": "Konfirmasi nama & nominal, tekan Ya.",
    "BNI手机银行": "BNI Mobile Banking",
    "BNI手机银行 步骤1": "Login BNI Mobile Banking.",
    "BNI手机银行 步骤2": "Pilih Transfer → Virtual Account Billing.",
    "BNI手机银行 步骤3": "Masukkan nomor Virtual Account.",
    "BNI手机银行 步骤4": "Pilih rekening debet, konfirmasi dengan OTP.",
    "网银BNI": "Internet Banking BNI",
    "网银BNI 步骤1": "Login ke ibank.bni.co.id.",
    "网银BNI 步骤2": "Pilih Transfer → Virtual Account Billing.",
    "网银BNI 步骤3": "Masukkan nomor Virtual Account.",
    "网银BNI 步骤4": "Konfirmasi dengan token BNI.",
    "ATM BRI": "ATM BRI",
    "ATM BRI 步骤1": "Masukkan kartu ATM BRI & PIN.",
    "ATM BRI 步骤2": "Pilih Transaksi Lain → Pembayaran → Lainnya → BRIVA.",
    "ATM BRI 步骤3": "Masukkan nomor BRIVA (Virtual Account).",
    "ATM BRI 步骤4": "Cek nama & nominal, tekan Ya.",
    "BRImo": "BRImo",
    "BRImo 步骤1": "Login BRImo.",
    "BRImo 步骤2": "Pilih BRIVA.",
    "BRImo 步骤3": "Masukkan nomor Virtual Account.",
    "BRImo 步骤4": "Masukkan nominal & PIN, konfirmasi.",
    "网银BRI": "Internet Banking BRI",
    "网银BRI 步骤1": "Login ib.bri.co.id.",
    "网银BRI 步骤2": "Pilih Pembayaran → BRIVA.",
    "网银BRI 步骤3": "Masukkan nomor Virtual Account.",
    "网银BRI 步骤4": "Konfirmasi dengan mToken.",
    "ATM BSI": "ATM BSI",
    "ATM BSI 步骤1": "Masukkan kartu ATM BSI & PIN.",
    "ATM BSI 步骤2": "Pilih Bayar/Beli → Virtual Account.",
    "ATM BSI 步骤3": "Masukkan nomor Virtual Account.",
    "ATM BSI 步骤4": "Konfirmasi detail & nominal.",
    "BSI手机银行": "BSI Mobile",
    "BSI手机银行 步骤1": "Login BSI Mobile.",
    "BSI手机银行 步骤2": "Pilih Bayar → Virtual Account.",
    "BSI手机银行 步骤3": "Masukkan nomor Virtual Account.",
    "BSI手机银行 步骤4": "Konfirmasi dengan PIN.",
    "三宝垄银行手机银行": "Mobile Banking Sampoerna",
    "三宝垄银行手机银行 步骤1": "Login aplikasi mobile banking Sampoerna.",
    "三宝垄银行手机银行 步骤2": "Pilih Pembayaran → Virtual Account.",
    "三宝垄银行手机银行 步骤3": "Masukkan nomor Virtual Account.",
    "三宝垄银行手机银行 步骤4": "Periksa detail & konfirmasi dengan PIN.",
    "ATM Mandiri": "ATM Mandiri",
    "ATM Mandiri 步骤1": "Masukkan kartu ATM Mandiri & PIN.",
    "ATM Mandiri 步骤2": "Pilih Bayar/Beli → Lainnya → Multi Payment.",
    "ATM Mandiri 步骤3": "Masukkan kode perusahaan, lalu nomor Virtual Account.",
    "ATM Mandiri 步骤4": "Konfirmasi nama & nominal, tekan Benar.",
    "Livin' by Mandiri": "Livin' by Mandiri",
    "Livin Mandiri 步骤1": "Login Livin' by Mandiri.",
    "Livin Mandiri 步骤2": "Pilih Pembayaran → Multi Payment.",
    "Livin Mandiri 步骤3": "Masukkan kode perusahaan & nomor VA.",
    "Livin Mandiri 步骤4": "Konfirmasi dengan PIN.",
    "网银Mandiri": "Internet Banking Mandiri",
    "网银Mandiri 步骤1": "Login ibank.bankmandiri.co.id.",
    "网银Mandiri 步骤2": "Pilih Pembayaran → Multi Payment.",
    "网银Mandiri 步骤3": "Masukkan kode perusahaan & nomor VA.",
    "网银Mandiri 步骤4": "Konfirmasi dengan token.",
    "ATM Muamalat": "ATM Muamalat",
    "ATM Muamalat 步骤1": "Masukkan kartu ATM Muamalat & PIN.",
    "ATM Muamalat 步骤2": "Pilih Pembayaran → Virtual Account.",
    "ATM Muamalat 步骤3": "Masukkan nomor Virtual Account.",
    "ATM Muamalat 步骤4": "Konfirmasi nominal & tekan OK.",
    "Muamalat手机银行": "Mobile Banking Muamalat",
    "Muamalat手机银行 步骤1": "Login DIN by Muamalat.",
    "Muamalat手机银行 步骤2": "Pilih Pembayaran → Virtual Account.",
    "Muamalat手机银行 步骤3": "Masukkan nomor VA & konfirmasi dengan PIN.",
    "ATM Permata": "ATM Permata",
    "ATM Permata 步骤1": "Masukkan kartu ATM Permata & PIN.",
    "ATM Permata 步骤2": "Pilih Transaksi Lainnya → Pembayaran → Pembayaran Lainnya → Virtual Account.",
    "ATM Permata 步骤3": "Masukkan nomor Virtual Account.",
    "ATM Permata 步骤4": "Konfirmasi nama & nominal.",
    "PermataMobile X": "PermataMobile X",
    "PermataMobile X 步骤1": "Login PermataMobile X.",
    "PermataMobile X 步骤2": "Pilih Bayar Tagihan → Virtual Account.",
    "PermataMobile X 步骤3": "Masukkan nomor VA.",
    "PermataMobile X 步骤4": "Konfirmasi dengan PIN.",
    "Alfamart": "Alfamart",
    "Alfamart 步骤1": "Kunjungi gerai Alfamart terdekat.",
    "Alfamart 步骤2": "Sampaikan kepada kasir bahwa Anda ingin melakukan pembayaran melalui Alfamart.",
    "Alfamart 步骤3": "Sebutkan atau tunjukkan Kode Bayar Anda kepada kasir.",
    "Alfamart 步骤4": "Kasir akan memasukkan kode dan menampilkan total tagihan.",
    "Alfamart 步骤5": "Lakukan pembayaran dan simpan struk sebagai bukti pembayaran.",
    "Indomaret": "Indomaret",
    "Indomaret 步骤1": "Kunjungi gerai Indomaret terdekat.",
    "Indomaret 步骤2": "Sampaikan kepada kasir bahwa Anda ingin melakukan pembayaran tagihan.",
    "Indomaret 步骤3": "Sebutkan atau tunjukkan Kode Bayar Anda kepada kasir.",
    "Indomaret 步骤4": "Kasir akan memasukkan kode dan menampilkan total tagihan.",
    "Indomaret 步骤5": "Lakukan pembayaran dan simpan struk sebagai bukti pembayaran.",
    "我们先创建一个账号，这样你就可以开始唱歌并享受所有可用的功能了。": "Yuk buat akun dulu supaya kamu bisa mulai bernyanyi dan menikmati semua fitur yang tersedia.",
    "使用邮箱注册": "Daftar dengan Email",
    "我已经拥有一个 Rising 账户": "Sudah punya akun RiSing?",
    "确认密码": "Konfirmasi Kata Sandi",
    "开始发送代码": "Mulai Kirim Kode",
    "电话验证": "Verifikasi Ponsel",
    "在本文中": "Dalam Artikel ini",
    "订阅自动续费说明": "Paket RiSing akan diperpanjang otomatis {price} setiap {days} hari dan akan ditagihkan ke kartu kredit Anda hingga dibatalkan. Anda dapat membatalkan kapan saja melalui pengaturan akun.",
    "运费保险说明": "Asuransi pengiriman: {price} untuk {total} produk",
    "地址列表": "Daftar Alamat",
    "请填写送货目的地的地址/城市/区名称": "Tulis Nama Alamat / Kota / Kecamatan tujuan pengiriman",
    "添加新地址": "Tambah Alamat Baru",
    "主要的": "Utama",
    "更改地址": "Ubah Alamat",
    "将其设为主要地址": "Jadikan Alamat Utama",
    "更改此地址": "Ganti Alamat Ini?",
    "没有找到地址": "Tidak ada alamat yang ditemukan",
    "选择地点": "Pilih Tempat",
    "添加送货地址": "Tambah Alamat Pengiriman",
    "姓名": "Nama",
    "收件人姓名": "Nama Penerima",
    "收货地址第 1 行": "Baris Alamat Pengiriman 1",
    "其他详情（例如：楼栋/单元编号、基准值）": "Detail Lainnya (cth: Blok/Unit No Patokan)",
    "地址另存为": "Simpan Alamat sebagai",
    "地址标签": "Label Alamat",
    "例如：家庭、办公室或您需要的任何特定标签。": "Contoh: Rumah, Kantor, atau label spesifik yang kamu butuhkan.",
    "更改送货地址": "Ubah Alamat Pengiriman",
    "更新": "Perbarui",
    "删除促销？": "Hapus Promo?",
    "您确定要删除此促销活动吗？如果您想再次添加，则需要手动重新输入代码。": "Apakah kamu yakin ingin menghapus promo ini? Kamu harus input kode kembali secara manual atau memilih dari daftar voucher jika ingin menambahkannya lagi.",
    "是的，删除": "Ya, hapus",
    "选择": "Pilih",
    "尚未保存任何收货地址": "Belum ada Alamat Pengiriman yang tersimpan",
    "快来添加您的收货地址，这样您在 Rising 购物时会更方便。": "Yuk, tambah Alamat Pengiriman kamu biar lebih mudah saat belanja di Rising",
    "添加地址": "Tambah Alamat",
    "请填写邮箱地址": "Harap isi email",
    "请填写手机号码": "Harap isi nomor ponsel",
    "输入身份证号码": "Masukkan nomor identitas",
    "请填写身份证号码": "Harap isi nomor identitas",
    "出生月份": "Bulan Lahir",
    "出生年份": "Tahun Lahir",
    "NPWP 数量": "Nomor NPWP",
    "添加新信用卡": "Tambah Kartu Kredit Baru",
    "地址不可用": "Alamat tidak tersedia",
    "合同信息": "Informasi Kontak",
    "只能上传 JPG/PNG/SVG 格式的图片!": "Hanya dapat mengunggah file gambar (JPG/PNG/SVG)!",
    "上传图片大小不能超过 2MB!": "Ukuran gambar tidak boleh melebihi 2MB!",
    "验证码提示": "Masukkan kode 6 digit yang telah kami kirimkan ke Nomor Ponsel kamu +62{prefix}-xxxx-{suffix}",
    "请输入您的手机号码，无需输入前导零。": "Masukkan nomor ponsel dengan awalan 08, 628, atau +628 (misalnya: +628123456789)",
    "手机号码不匹配": "Nomor ponsel tidak sesuai standar",
    "更新地址": "Perbarui Alamat",
    "确认设为主要地址": "Apakah anda yakin ingin menggunakan alamat ini sebagai alamat utama anda?",
    "从购物车中移除商品": "Hapus Produk dari Keranjang?",
    "确认从购物车中删除商品": "Apakah kamu yakin ingin menghapus produk ini dari keranjang?",
    "返回主页": "Kembali ke Halaman Utama",
    "页面未找到": "Halaman Tidak ditemukan",
    "请仔细检查网址，或返回主页。": "Periksa kembali URL atau kembali ke halaman utama.",
    "WhatsApp标题": "Mulai Percakapan",
    "WhatsApp描述": "Hai! Klik salah satu anggota kami di bawah untuk chat di <strong>Whatsapp</strong>",
    "WhatsApp回复时间": "Tim biasanya membalas dalam beberapa menit.",
    "WhatsApp客服": "Layanan Pelanggan",
    "WhatsApp招聘": "Pusat Rekrutmen",
    "设备已激活": "PERANGKAT BERHASIL DIAKTIFKAN",
    "设备激活描述": "Perangkat RiSing Anda telah berhasil diaktifkan dan siap digunakan.",
    "检查设备状态": "Cek status perangkat",
    "PERANGKAT MAC ADDRESS": "PERANGKAT MAC ADDRESS",
    "Semua perangkat terhubung ke akun": "Semua perangkat terhubung ke akun",
    "Aktif": "Aktif",
    "Kedaluwarsa": "Kedaluwarsa",
    "Aktif sampai": "Aktif sampai",
    "Berakhir pada": "Berakhir pada",
    "Perbarui Langganan": "Perbarui Langganan",
    "Tambah Langganan": "Tambahkan Langganan",
    "Ubah Langganan": "Ubah Langganan",
    "EMAIL VERIFIKASI TELAH DIKIRIM": "EMAIL VERIFIKASI TELAH DIKIRIM",
    "Kami telah mengirim email verifikasi berisi tautan ke": "Kami telah mengirim email verifikasi berisi tautan ke",
    "Tautan tersebut akan kedaluwarsa dalam 24 jam. Jika Anda tidak menemukannya di kotak masuk, silakan periksa folder Sampah /Spam.": "Tautan tersebut akan kedaluwarsa dalam 24 jam. Jika Anda tidak menemukannya di kotak masuk, silakan periksa folder Sampah/Spam.",
    "Jika masih belum menerima email verifikasi, klik tombol Kirim Ulang di bawah ini.": "Jika masih belum menerima email verifikasi, klik tombol Kirim Ulang di bawah ini.",
    "Akses hari": "Akses {days} hari",
    "歌曲请求2": "Usulkan Lagu",
    "歌曲请求": "USULKAN LAGU",
    "还没找到你要的歌曲吗？": "Belum menemukan lagu yang kamu cari?",
    "提交歌曲详情，我们将帮助添加到目录中。": "Kirim usulan dengan mengisi detail lagu, dan kami akan bantu menambahkannya ke katalog.",
    "歌曲": "LAGU",
    "删除歌曲": "Hapus lagu",
    "歌曲名称": "Judul Lagu",
    "请输入歌曲名称": "Isi judul lagu",
    "歌手姓名": "Nama Penyanyi",
    "请输入歌手姓名": "Isi nama penyanyi lagu",
    "参考链接（可选）": "Link Referensi (Opsional)",
    "添加参考链接": "Tambahkan link referensi",
    "补充说明（可选）": "Catatan Tambahan (Opsional)",
    "添加说明": "Tambahkan Catatan",
    "添加歌曲": "Tambah Lagu",
    "联系方式（可选）": "KONTAK YANG DAPAT DIHUBUNGI (OPSIONAL)",
    "如果您希望在歌曲成功添加后收到通知，请填写以下信息。": "Isi data di bawah jika kamu ingin kami hubungi saat lagu yang kamu minta berhasil ditambahkan.",
    "请输入您的姓名": "Isi nama kamu",
    "邮箱/电话号码": "Email/Phone Number",
    "请输入邮箱或电话号码": "Isi email atau nomor telepon",
    "发送中...": "Mengirim...",
    "提交歌曲": "Ajukan Lagu",
    "歌曲请求发送成功": "PERMINTAAN LAGU BERHASIL DIKIRIM",
    "我们已收到您的歌曲请求，我们的团队将先进行审核。": "Permintaan lagu kamu sudah kami terima. Tim kami akan melakukan kurasi terlebih dahulu.",
    "请期待您选择的歌曲很快出现在您的VOD中。谢谢！": "Nantikan lagu pilihanmu segera hadir di VOD kamu. Terima kasih!",
    "前往商店": "Ke Toko",
    "再次提交歌曲": "Usulkan Lagu Lagi",
    "常见问题": "Pertanyaan yang Sering Diajukan",
    "我们整理了常见问题，帮助您更轻松地了解和使用RiSing。": "Kami telah merangkum berbagai pertanyaan umum untuk membantu Anda memahami dan menggunakan RiSing dengan lebih mudah.",
    "没有找到您的问题？": "Tidak menemukan pertanyaanmu?",
    "新手包套装说明1": "RiSing STARTER PACK RTX3M206 SPH (PERUNTUKAN RUMAH, PERSONAL, DAN NON-KOMERSIAL)",
    "新手包简介1": "Aktifkan karaoke di TV dan sound system rumahmu",
    "新手包功能1_1": "Set-Top Box karaoke siap dipakai",
    "新手包功能1_2": "Akses ke 80.000+ lagu karaoke selama 1 Tahun",
    "新手包功能1_3": "Ideal untuk Anda yang sudah memiliki sistem audio karaoke, home cinema, dan speaker aktif",
    "新手包功能1_4": "Tanpa iklan, karaoke tanpa gangguan",
    "新手包备注1": "Biaya langganan Rp150.000 per bulan untuk bulan berikutnya",
    "新手包套装说明2": "RiSing KARAOKE CONSOLE ONE RS4P216 SPH (PERUNTUKAN RUMAH, PERSONAL, DAN NON-KOMERSIAL)",
    "新手包简介2": "Solusi karaoke all-in-one, tinggal nyalakan dan nyanyi",
    "新手包功能2_1": "Paket karaoke lengkap dengan speaker, sistem karaoke, dan mic wireless",
    "新手包功能2_2": "Akses ke 80.000+ lagu karaoke selama 365 hari",
    "新手包功能2_3": "Ideal untuk Anda yang hanya mempunyai TV dan membutuhkan setup karaoke all-in-one",
    "新手包功能2_4": "Instalasi mudah dan praktis",
    "新手包备注2": "Biaya langganan Rp 900.000 per tahun untuk tahun berikutnya",
    "新手包cta": "Mulai Karaoke Sekarang​",
    "FAQ问题1": "<strong>Apa itu RiSing?</strong>",
    "FAQ答案1": "RiSing merupakan layanan home entertainment karaoke yang menghadirkan sistem hiburan dan perangkat karaoke untuk menemani momen bersama keluarga dan teman, khusus untuk penggunaan pribadi (nonkomersial).",
    "FAQ问题2": "<strong>Apa saja produk karaoke RiSing?</strong>",
    "FAQ答案2": "<strong>RiSing punya 2 produk utama:</strong>\n• <strong>Set-Top Box (STB)</strong> — perangkat yang mengubah TV dan speaker yang sudah dimiliki menjadi sistem karaoke di rumah​.\n• <strong>Console One</strong> — speaker sekaligus sistem karaoke dalam satu perangkat, lengkap dengan dua mikrofon nirkabel. Cocok untuk pengalaman karaoke yang lebih praktis karena dapat langsung digunakan.​",
    "FAQ问题3": "<strong>⁠Apakah Set-Top Box dan Console One dibeli putus?</strong>",
    "FAQ答案3": "Ya. Set-Top Box (STB) dan Console One dapat dibeli secara putus dengan satu kali pembayaran di awal dan perangkat menjadi milik pelanggan sepenuhnya. \n\nSetiap pembelian sudah mencakup akses lagu karaoke sesuai dengan paket yang dipilih. Setelah masa akses berakhir, pelanggan dapat memperpanjang langganan dengan biaya Rp150.000 untuk 30 hari atau Rp900.000 untuk 12 bulan.​</strong>.",
    "FAQ问题4": "Berapa lama masa akses lagu karaoke yang didapatkan?​​",
    "FAQ答案4": "<strong>• RiSing Starter Pack (STB) dilengkapi masa akses selama 3 bulan atau 12 bulan, sesuai dengan paket yang dipilih.​</strong>​\n<strong>• RiSing Karaoke Console One dilengkapi masa akses selama 12 bulan.​</strong>\n\nSetelah masa akses berakhir, akses lagu karaoke dapat diperpanjang dengan biaya Rp150.000 untuk 30 hari atau Rp900.000 untuk 12 bulan.​\n\nAkses hanya perlu dibeli saat ingin Kembali menggunakan layanan karaoke. RiSing tidak menerapkan sistem tagihan otomatis.",
    "FAQ问题5": "Apakah ada paket langganan tahunan atau mingguan?​​​",
    "FAQ答案5": "Saat ini RiSing hanya menyediakan paket akses karaoke 1 bulan (Rp150.000) dan akses karaoke 12 bulan/1 tahun (Rp900.000​)​",
    "FAQ问题6": "<strong>⁠Apakah ini seperti langganan bulanan yang berjalan otomatis?</strong>​",
    "FAQ答案6": "Akses karaoke RiSing bersifat <strong>on-demand</strong>, bukan auto-renewal (kecuali pembayaran dengan kartu kredit). Apabila masa aktif telah berakhir dan Anda belum membutuhkannya, Anda tidak perlu membayar apa pun — Anda dapat membeli akses kembali kapan pun ingin menggunakannya.",
    "FAQ问题7": "<strong>⁠Bagaimana sistem pemasangan bagi pelanggan di luar Surabaya?</strong>​",
    "FAQ答案7": "Pemasangan STB dan Console One sangat praktis dan dapat dilakukan secara <strong>mandiri</strong>. Namun, apabila Anda membutuhkan bantuan, tim RiSing siap memandu secara <strong>online</strong>, atau mengirimkan teknisi langsung untuk <strong>area yang termasuk dalam cakupan layanan kami​</strong>.",
    "FAQ问题8": "<strong>Apakah lagu-lagu di RiSing diperbarui secara berkala?​</strong>​",
    "FAQ答案8": "Ya. Katalog lagu RiSing diperbarui secara rutin setiap bulan. Jika lagu yang dicari belum tersedia, pengguna juga dapat mengajukan permintaan melalui halaman <a href=\"/request-song\"><strong>Usulkan Lagu</strong></a>.\n Lagu baru akan diproses dalam waktu sekitar satu bulan tergantung pada proses produksi​",

    "设定订购数量": "Atur Jumlah Pesanan",
    "购买小计": "Subtotal Pembelian",
    "直接购买": "Beli langsung",
    "篮子": "Keranjang",
    "下载安装指南": "Unduh Panduan Instalasi",
    "选择订阅时长": "Pilih Durasi Langganan Anda",
    "订购数量": "Jumlah Order",
    "正在加载...": "Memuat...",
    "我知悉，我提供的电子邮箱地址或手机号码将用作我的 RiSing 账户。": "Saya memahami bahwa email/nomor ponsel yang saya isi akan digunakan sebagai akun RiSing saya.",
    "请确认您知悉您的电子邮箱或手机号码将用作您的 RiSIng 账户。": "Setujui bahwa anda memahami email/nomor ponsel akan digunakan sebagai akun RiSIng.",
    "联系方式（可选）": "Kontak (Opsional)",
    "邮箱格式不正确": "Format email tidak valid.",
    "结账失败；发生错误。": "Checkout gagal, terjadi kesalahan",
    "我们已收到您的付款。您可以随时登录账户查看状态并管理订单。": "Pembayaranmu telah kami terima. Masuk ke akun untuk melihat status dan mengelola pesananmu kapan saja.",
    "交易成功": "Transaksi berhasil",
    "登录您的账户": "Masuk ke akun",
    "尽享各项不断升级的功能": "Jelajahi Semua Fitur RiSing",
    "付款已成功收到。请在订单页面查看订单详情及状态。": "Pembayaran berhasil diterima. Cek detail dan status pesananmu di halaman pesanan.",
    "下载发票": "Unduh Invoice",
    "扫描二维码": "Scan QRIS",
    "下载 QRIS": "Unduh QRIS",
    "付款方式": "Metode Pembayaran",
    "订阅有效期": "Masa Aktif Langganan",
    "更改服务地点": "Ubah Lokasi Layanan",
    "信用卡支付": "Credit Card Payment",
    "Mulai dari": "Mulai dari",
    "Berakhir Sampai": "Berakhir Sampai",
    "您好，欢迎光临！": "Halo, selamat datang!​",
    "登录/注册": "Masuk/daftar",
    "开始在家唱卡拉OK": "untuk mulai berkaraoke di rumah​",
    "……的一部分": "Bagian dari",
    "由……支持": "Didukung oleh",
    "官方音乐许可": "Lisensi Musik Resmi",
    "新手包标签_畅销": "Terlaris",
    "kata_sandi": "Kata Sandi",
    "ubah_kata_sandi": "Ubah Kata Sandi",
    "ubah_kata_sandi_desc": "Apabila terdapat aktivitas yang bukan berasal dari Anda, segera perbarui kata sandi akun.",
    "belum_ada_metode": "Belum ada metode pembayaran yang tersimpan",
    "belum_ada_metode_desc": "Yuk, tambah Metode Pembayaran Anda biar lebih mudah saat belanja di Rising",
    "kirim_tautan_pre_1": "Kami akan mengirimkan tautan untuk mengatur ulang kata sandi ke ",
    "kirim_tautan_pre_2": ". Silakan tekan tombol kirim dibawah, lalu verifikasi email anda untuk melanjutkan proses dan membuat kata sandi baru.",
    "kirim_tautan_1": "Kami telah mengirimkan tautan untuk mengatur ulang kata sandi ke ",
    "kirim_tautan_2": ". Silakan buka email tersebut, lalu klik tombol Verifikasi Email untuk melanjutkan proses dan membuat kata sandi baru.",
    "verifikasi_email_anda": "Verifikasi email anda",
    "kirim_tautan": "Kirim tautan",
    "kirim_ulang_tautan": "Kirim ulang tautan",
    "batalkan": "Batalkan",
    "前往计费页面": "Lihat Pesanan",
    "MASUKKAN KODE VOUCHER ANDA": "MASUKKAN KODE VOUCHER ANDA",
    "Perangkat ini terdaftar atas nama reseller.": "Perangkat ini terdaftar atas nama reseller.",
    "Masukkan kode voucher unik yang terdapat pada Kartu Selamat Datang di dalam kotak perangkat Anda untuk melanjutkan.": "Masukkan kode voucher unik yang terdapat pada Kartu Selamat Datang di dalam kotak perangkat Anda untuk melanjutkan.",
    "Voucher Code": "Kode Voucher",
    "Kode voucher tercetak pada kartu yang terdapat di dalam kotak RiSing Anda.": "Kode voucher tercetak pada kartu yang terdapat di dalam kotak RiSing Anda.",
    "Verifikasi Voucher": "Verifikasi Voucher",
    "KODE VOUCHER TELAH KEDALUWARSA": "KODE VOUCHER TELAH KEDALUWARSA",
    "Kode voucher ini telah kedaluwarsa. Voucher berlaku selama 1 tahun sejak tanggal pembelian. Jika perangkat Anda belum diaktifkan dalam jangka waktu tersebut, silakan hubungi Customer Support kami untuk mendapatkan kode voucher baru.": "Kode voucher ini telah kedaluwarsa. Voucher berlaku selama 1 tahun sejak tanggal pembelian. Jika perangkat Anda belum diaktifkan dalam jangka waktu tersebut, silakan hubungi Customer Support kami untuk mendapatkan kode voucher baru.",
    "Hubungi Dukungan Pelanggan": "Hubungi Dukungan Pelanggan",
    "Jam operasional: Senin-Sabtu, 09.00-18.00 WIB. (untuk layanan/bisnis)": "Jam operasional: Senin-Sabtu, 09.00-18.00 WIB. (untuk layanan/bisnis)",
    "WhatsApp CS": "WhatsApp CS",
    "Atau": "Atau",
    "Coba dengan kode voucher lain": "Coba dengan kode voucher lain",
    "choose_service_package": "Pilih Paket layanan",
    "start_karaoke_now": "Mulai Karaoke Sekarang",
    "product_not_found": "Product Not Found",
    "stb_title": "PILIH PAKET AKSES KARAOKEMU!",
    "stb_feat_1": "Set-Top Box karaoke siap dipakai",
    "stb_feat_2": "Akses ke 80.000+ lagu karaoke selama 3 bulan atau 12 bulan",
    "stb_feat_3": "Tanpa iklan, karaoke tanpa gangguan",
    "console_title": "SIAP MULAI KARAOKE DARI RUMAH?",
    "console_feat_1": "Paket karaoke lengkap dengan speaker, sistem karaoke, dan mic wireless",
    "console_feat_2": "Akses ke 80.000+ lagu karaoke selama 1 Tahun",
    "console_feat_3": "Ideal untuk Anda yang hanya mempunyai TV dan membutuhkan setup karaoke all-in-one",
    "console_feat_4": "Instalasi mudah dan praktis",
    "stb_top_title": "RiSing Karaoke Set-Top Box",
    "stb_big_title": "UBAH TV BIASA JADI KARAOKE",
    "stb_subtitle": "Untuk keseruan maksimal di rumah",
    "get_it_here": "Dapatkan Disini",
    "stb_banner_title": "NYANYI SEPUASNYA,\nKINI BISA DI RUMAH!",
    "stb_banner_desc": "RiSing Karaoke STB menghadirkan <strong>pengalaman karaoke di rumah yang lebih praktis.</strong> Cukup <strong>sambungkan ke TV</strong>, speaker dan Wi-Fi, lalu nikmati akses ke <strong>puluhan ribu lagu karaoke dari berbagai genre kapan saja.</strong>",
    "stb_banner_subdesc": "Produk ini cocok untuk Anda yang sudah memiliki speaker, sound system atau home theater di rumah.",
    "common_feat1_title": "PENGALAMAN KARAOKE HAPPY PUPPY,\nLANGSUNG DI RUMAH",
    "common_feat1_desc": "Bawa pengalaman karaoke favoritmu ke rumah dengan fitur minus one, naik-turunkan nada, running text, dan queue lagu. Tinggal pilih lagu, atur sesukamu, dan mulai bernyanyi!",
    "stb_feat2_title": "DESAIN PRAKTIS,\nMUDAH DIBAWA KE MANA-MANA",
    "stb_feat2_desc": "Alat karaoke praktis dengan desain minimalis, ukuran ringkas, dan bobot ringan.",
    "stb_feat2_subdesc": "Mudah disimpan dan dibawa saat ingin karaoke di rumah, berkumpul bersama keluarga, maupun seru-seruan bersama teman.",
    "common_feat3_title": "KONTROL MUDAH\nDENGAN SMARTPHONE",
    "common_feat3_desc": "Cukup scan QR code di layar, lalu kontrol dan akses semua kebutuhan karaoke langsung melalui smartphone.",
    "common_preview_title": "CUKUP PASANG, LANGSUNG NYANYI!",
    "console_top_title": "RiSing Karaoke Console One",
    "console_big_title": "ALL-IN-ONE SPEAKER KARAOKE",
    "console_subtitle": "Untuk pengalaman karaoke maksimal",
    "console_banner_title": "SUARA POWERFUL,\nKARAOKE MAKIN MAKSIMAL",
    "console_banner_desc": "RiSing Karaoke Console One menghadirkan audio yang lebih bertenaga dan jernih dengan <strong>woofer, tweeter, dan full-range speaker.</strong>",
    "console_banner_subdesc": "Nikmati vokal yang terdengar lebih jelas, detail musik yang lebih terasa, serta pengalaman karaoke yang lebih seru dan hidup di rumah.",
    "console_feat2_title": "2X MIKROFON NIRKABEL",
    "console_feat2_desc": "Vokal Jernih Bebas Feedback",
    "spec_impedance": "Nominal\nImpedance",
    "spec_freq_response": "Bass Frequency\nResponse",
    "spec_peak_power": "Peak Power",
    "spec_mic_title": "Wireless UHF Microphone",
    "spec_mic_desc": "Koneksi mic yang stabil",
    "spec_range_title": "25M Wireless Range",
    "spec_range_desc": "Jangkauan hingga 25 Meter",
    "spec_battery_title": "5H Battery Life",
    "spec_battery_desc": "Daya tahan hingga 5 Jam",

    // reseller page
    "reseller_link_text": "Gabung Reseller",
    "reseller_hero_title": "GABUNG SEBAGAI RESELLER",
    "reseller_btn_register": "Daftar Sekarang",
    "reseller_intro_title": "Mau Cuan Tanpa Ribet? Yuk, Jadi Reseller RiSing!",
    "reseller_intro_desc": "Nggak perlu modal, nggak perlu jago teknis. Cukup gabung, mulai jualan, dan nikmati penghasilan tambahan yang terus mengalir. Waktunya Anda naik level bersama RiSing. Daftar sekarang, mulai untung hari ini!",
    "reseller_desc_title": "APA ITU RESELLER?",
    "reseller_desc_subtitle": "Jadi Mitra Resmi RiSing, Untung Hingga 8% Tanpa Modal",
    "reseller_desc_text": "Perkenalkan dan jual RiSing Set-Top Box serta RiSing Console One kepada pelanggan di berbagai wilayah sebagai Reseller resmi. Tanpa modal awal, kamu sudah bisa mulai dan mendapatkan keuntungan hingga 8% dari setiap transaksi.",
    "reseller_step_title": "PROGRAM RESELLER",
    "reseller_step_desc": "Tiga langkah sederhana untuk mulai berjualan dan meraih peluang bersama RiSing.",
    "reseller_step1_title": "Terima Stock dan PoP RiSing",
    "reseller_step1_desc": "Terima RiSing Set-Top Box, RiSing Console One dan juga PoP untuk perlengkapan penjualan.",
    "reseller_step2_title": "Jual ke Konsumen",
    "reseller_step2_desc": "Jual RiSing Set-Top Box dengan harga minimum Rp1.500.000, Jual RiSing Console One dengan harga minimum Rp 4.500.000.",
    "reseller_step3_title": "Dapatkan Komisi",
    "reseller_step3_desc": "Setiap unit terjual mendapatkan komisi dari harga jual Set-Top Box dan RiSing Console One. komisi diakumulasikan di akhir bulan.",
    "reseller_benefit_title": "KEUNTUNGAN PROGRAM RESELLER",
    "reseller_benefit_desc": "Waktunya Anda naik level bersama RiSing. Daftar sekarang, mulai untung hari ini!",
    "reseller_benefit1_title": "Tanpa Modal di Depan",
    "reseller_benefit1_desc": "Stock kami yang tanggung, tidak ada resiko barang tidak laku",
    "reseller_benefit2_title": "Support dari RiSing",
    "reseller_benefit2_desc": "Materi promosi, training produk, dan dukungan after-sales pelanggan",
    "reseller_benefit3_title": "Komisi Naik Otomatis",
    "reseller_benefit3_desc": "Makin banyak jual makin banyak komisi yang didapatkan",
    "reseller_benefit4_title": "Harga Jual Sudah Ditetapkan",
    "reseller_benefit4_desc": "Tidak ada kompetisi harga",
    "reseller_term_title": "Syarat & Ketentuan",
    "reseller_term_desc": "Informasi penting yang perlu diketahui dalam kerja sama bersama RiSing.",
    "reseller_term1_desc": "Harga jual ke konsumen tidak diperkenankan menjual di bawah harga resmi yaitu RiSing Set-Top Box : Rp1.500.000 dan RiSing Console One : Rp4.500.000",
    "reseller_term2_desc": "Semua penjualan ke end user dilakukan dari website RiSing dengan memasukkan kode voucher reseller",
    "reseller_term3_desc": "Rekap penjualan setiap bulannya akan dilakukan oleh pihak RiSing, paling lambat tanggal 5 setiap bulannya di bulan berikutnya",
    "reseller_term4_desc": "Reseller menerima pembayaran dari end user secara langsung. Selanjutnya, reseller wajib menyetorkan hasil penjualan kepada RiSing setelah dikurangi komisi reseller, paling lambat H+7 setelah akhir bulan berjalan",
    "reseller_term5_desc": "Pemutusan kerja sama dilakukan 30 hari sebelumnya",
    "reseller_pop_title": "POINT OF PURCHASE (POP)",
    "reseller_pop_desc": "Berbagai materi pendukung yang digunakan di area penjualan untuk memperkenalkan RiSing.",
    "reseller_pop1_title": "TV/Stand",
    "reseller_pop1_desc": "Menampilkan VOD RiSing agar calon pembeli dapat mencoba",
    "reseller_pop2_title": "Tent Card",
    "reseller_pop2_desc": "Menampilkan informasi singkat mengenai produk / fitur",
    "reseller_pop3_title": "T Banner",
    "reseller_pop3_desc": "Media visual berukuran besar untuk memperkenalkan RiSing",
    "reseller_pop4_title": "RiSing Display Arkilik",
    "reseller_pop4_desc": "Materi visual untuk menarik perhatian pengunjung STB.",
    "reseller_pop5_title": "Brochure",
    "reseller_pop5_desc": "Materi informasi produk yang dapat dibagikan kepada customer.",
    "reseller_form_title": "JADI RESELLER KAMI SEKARANG!",
    "reseller_form_desc": "Isi data diri pada form ini, dan kami akan segera menghubungi Anda.",
    "reseller_form_subtitle": "Isi data diri di bawah ini, dan kami akan segera menghubungi Anda.",
    "reseller_form_place_name": "Nama Toko",
    "reseller_form_place_name_placeholder": "Nama toko di mana produk akan dijual",
    "reseller_form_pic_name": "Nama PIC",
    "reseller_form_pic_name_placeholder": "Nama PIC",
    "reseller_form_number": "Nomor WhatsApp",
    "reseller_form_number_placeholder": "Contoh: 628*******",
    "reseller_form_address": "Detail Alamat",
    "reseller_form_address_placeholder": "Masukkan lokasi lengkap",
    "reseller_form_province": "Provinsi",
    "reseller_form_city": "Kota",
    "reseller_form_district": "Kecamatan",
    "reseller_form_subdistrict": "Kelurahan",
    "reseller_form_postal": "Kode Pos",
    "reseller_form_select": "Select",
    "reseller_form_submit": "Kirim Pendaftaran",
    "reseller_form_required": "wajib diisi",
    "reseller_form_format": "dan sesuai format",
    "reseller_form_loading": "Memuat...",
    "reseller_form_success": "Pendaftaran berhasil dikirim! Kami akan segera menghubungi Anda.",
    "reseller_form_error": "Gagal mengirim pendaftaran. Silakan coba lagi.",
    "reseller_success_title": "PENDAFTARAN BERHASIL DIKIRIM!",
    "reseller_success_desc": "Terima kasih telah mendaftar sebagai Reseller RiSing. Permohonan Anda telah kami terima dan tim kami akan segera menghubungi Anda.",
    "reseller_success_btn": "Kirim Pendaftaran Lain"
};
